import React, { useEffect, useState } from 'react';
import { useClientPortal } from '../../../context/ClientPortalContext';
import { PortalProfileService } from '../../../services/portal/portalProfileService';

const ProfileFamily = () => {
    const { clientId } = useClientPortal();
    const [dependents, setDependents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (clientId) {
            loadFamily();
        }
    }, [clientId]);

    const loadFamily = async () => {
        setLoading(true);
        const { data } = await PortalProfileService.listDependents(clientId);
        setDependents(data || []);
        setLoading(false);
    };

    if (loading) return <div className="p-6 text-center text-slate-500">Loading family details...</div>;

    return (
        <div className="space-y-6">
            <section className="bg-white border border-slate-200 rounded-2xl p-6">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-slate-900">Family & Dependents</h3>
                </div>

                {dependents.length === 0 ? (
                    <p className="text-sm text-slate-500">No dependents listed.</p>
                ) : (
                    <div className="space-y-4">
                        {dependents.map((dep, index) => (
                            <div key={index} className="p-4 border border-slate-100 rounded-lg bg-slate-50">
                                <h4 className="font-medium text-slate-900">{dep.name}</h4>
                                <p className="text-sm text-slate-600">{dep.relationship}</p>
                                <p className="text-xs text-slate-500 mt-1">DOB: {dep.date_of_birth}</p>
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default ProfileFamily;
